export default __webpack_public_path__ + "static/media/MwRight.ca55ed93.svg";